import CustomView from "./custom-view";
import {ViewType} from "../../gd/const/views/view-type";
import ViewExpenses from "./views/expenses/expenses"
import CustomView_GList from "./views/glist/glist";

export default function customViewFactory(customViewData:any):CustomView|null {

    const type = customViewData.type || customViewData.viewType

    switch (type) {
        // case ViewType.MY_WORK_CALENDAR:
        //     return new ViewMyCalendar(customViewData)

        // case ViewType.MY_TASKS_LIST:
        //     return new ViewMyTasks(customViewData)

        // case ViewType.MY_NOTES:
        //     return new ViewNotepad(customViewData)

        // case ViewType.MY_GOALS:
        //     return new ViewMyGoals(customViewData)

        // case ViewType.MY_ATTENDANCE:
        //     return new ViewMyAttendance(customViewData)

        // --- old
        case ViewType.MY_WORK_CALENDAR:
        case ViewType.MY_TASKS_LIST:
        case ViewType.MY_NOTES:
        case ViewType.MY_GOALS:
        case ViewType.MY_ATTENDANCE:
            return null

        case ViewType.CUSTOM_VIEW_CUSTOM_ENTITY_GLIST:
            return new CustomView_GList(customViewData)

        case ViewType.CUSTOM_VIEW_EXPENSES:
            return new ViewExpenses(customViewData)

        default:
            return new CustomView(customViewData)

    }
}
